import { render, staticRenderFns } from "./SheduleVisit.vue?vue&type=template&id=b52bf284&"
import script from "./SheduleVisit.vue?vue&type=script&lang=js&"
export * from "./SheduleVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports